import {Flex, Box, Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import i18next from 'i18next'

import {NextScreenHeader as ScreenHeader} from '~/react/components/ScreenHeader'
import withProviders from '~/react/contexts/withProviders'
import PointsActivitiesTable from './PointsActivitiesTable'
import EmptyState from './EmptyState'
import {usePointsBalance} from '../../hooks/usePointsBalance'
import {useActivities} from '../../hooks/useActivities'

const PointsActivitiesScreen = () => {
  i18next.loadNamespaces('points')
  const {t} = useTranslation()

  const {activities, loading: isLoadingActivities} = useActivities()

  const {pointsBalance: balance, loading: isLoadingBalance} = usePointsBalance()

  return (
    <>
      <ScreenHeader text={t('points:activitiesScreen.title')} />

      <Box p="md" borderRadius="lg" background="mld.neutral.0">
        <Text
          textStyle="headline4"
          color="neutral.700"
          textTransform="uppercase"
        >
          {t('points:activitiesScreen.balance')}
        </Text>

        <Flex direction="row" gap="xs" pt="sm" pb="md" alignItems="flex-end">
          <Text textStyle="headline2" color="black">
            {isLoadingBalance ? '...' : balance.toLocaleString()}
          </Text>
          <Text textStyle="headline5" color="black" textTransform="uppercase">
            {t('common:marmaladeRewardCurrency')}
          </Text>
        </Flex>

        <Flex minH="100vh" direction="column" gap="sm">
          {activities.length === 0 && !isLoadingActivities ? (
            <EmptyState
              title={t('points:activitiesScreen.emptyState.title')}
              description={t('points:activitiesScreen.emptyState.description')}
            />
          ) : (
            <PointsActivitiesTable
              activities={activities}
              isLoading={isLoadingActivities}
            />
          )}
        </Flex>
      </Box>
    </>
  )
}

export default withProviders(PointsActivitiesScreen)
